export default "__VITE_ASSET__4e79bf04__"